import React from "react"
import { useTranslation } from "react-i18next"

import { ProductInformation } from "shared/types/__generated__/graphql"
import { Readonly } from "shared/ui/readonly/Readonly"

interface ProductPositionRowAddonsTooltipProps {
  productInformation: ProductInformation | null | undefined
}

export const ProductPositionRowAddonsTooltip = React.memo(
  ({ productInformation }: ProductPositionRowAddonsTooltipProps) => {
    const { t } = useTranslation()

    return (
      <div className="addons-tooltip">
        <Readonly.Root>
          <Readonly.Label>
            {t("Product.Configuration.Addon.Addons")}
          </Readonly.Label>
          <Readonly.Value>
            {productInformation?.addons?.map(addon => (
              <div key={`${addon.variantKey}-title`}>{addon.title}</div>
            ))}
          </Readonly.Value>
        </Readonly.Root>
        <Readonly.Root>
          <Readonly.Label>{t("ProjectExport.AddonKeys")}</Readonly.Label>
          <Readonly.Value>
            {productInformation?.addons?.map(addon => (
              <div key={`${addon.variantKey}-variant-key`}>
                {addon.variantKey}
              </div>
            ))}
          </Readonly.Value>
        </Readonly.Root>
      </div>
    )
  }
)
